import { useRef } from 'preact/hooks';
import type { RefObject } from 'preact';

/**
 * 贴底跟随滚动 —— web 客服与数字人客服共用。
 *
 * 修复「AI 流式回复期间无法上滚看历史」:原实现 messages 每次变化
 * (流式 delta 高频触发)都无条件 scrollTop = scrollHeight,用户刚上滚
 * 就被拽回底部。现在仅当视图处于贴底状态(距底 ≤ STICK_THRESHOLD_PX)
 * 时才跟随滚动;用户上滚超过阈值即暂停吸底,滚回底部后自动恢复跟随。
 */
export interface StickToBottom {
  /** 绑定到滚动容器 onScroll,按距底距离更新贴底状态 */
  handleBodyScroll: (el: HTMLDivElement) => void;
  /** 自动滚动 effect 内调用:仅贴底时吸底 */
  scrollIfStuck: () => void;
  /** 用户主动发消息时调用:恢复贴底(自己的消息必须立即可见),随后 messages effect 完成吸底 */
  pinToBottom: () => void;
}

/** 距底 ≤ 该阈值视为贴底;取略大于一行的值,容忍贴底时的像素抖动 */
const STICK_THRESHOLD_PX = 48;

export function useStickToBottom(bodyRef: RefObject<HTMLDivElement>): StickToBottom {
  const stuckRef = useRef(true);

  const handleBodyScroll = (el: HTMLDivElement) => {
    stuckRef.current = el.scrollHeight - el.scrollTop - el.clientHeight <= STICK_THRESHOLD_PX;
  };

  const scrollIfStuck = () => {
    if (!stuckRef.current) return;
    const el = bodyRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  };

  const pinToBottom = () => {
    stuckRef.current = true;
  };

  return { handleBodyScroll, scrollIfStuck, pinToBottom };
}
